import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { RegexService } from 'src/app/services/regex.service';
import * as Countries from 'src/assets/json/countries.json';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix, MatHint, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-add-provider-dialog',
  templateUrl: './add-provider-dialog.component.html',
  styleUrls: ['./add-provider-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatSuffix,
    MatHint,
    MatCheckbox,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatPrefix,
  ],
})
export class AddProviderDialogComponent implements OnInit {
  protected fb = inject(UntypedFormBuilder);
  dialogRef = inject<MatDialogRef<AddProviderDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private regex = inject(RegexService);

  providerForm: UntypedFormGroup;
  countries: any[] = (Countries as any).default;

  constructor() {
    const regex_patterns = this.regex.getRegex();

    this.providerForm = this.fb.group({
      name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern(regex_patterns['phone'])])],
      website: [''],
      is_hosting_provider: [false],
      is_domain_provider: [false],
      is_business_mail_provider: [false],
      slug: ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      fact_name: ['', Validators.compose([Validators.required])],
      fact_address: ['', Validators.compose([Validators.required])],
      fact_city: ['', Validators.compose([Validators.required])],
      fact_zipcode: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
      fact_county: ['', Validators.compose([Validators.required])],
      fact_country: ['', Validators.compose([Validators.required])],
      fact_country_alpha2: ['', Validators.compose([Validators.required])],
      vat: ['', Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
    this.listenCountryChanges();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private listenCountryChanges() {
    this.providerForm.controls['fact_country'].valueChanges.subscribe(data => {
      for (const c of this.countries) {
        if (c.name == data) {
          this.providerForm.patchValue({ fact_country_alpha2: c.alpha_2 });
          break;
        }
      }
    });
  }
}
